import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import type { LaunchDarklyFlags } from '../types/launch-darkly';
import { usePartnerProfile } from './usePartnerSettings';

export function useAllFlags() {
  const ldClient = useLDClient();
  if (!ldClient) {
    throw new Error('useAllFlags must be used within LaunchDarklyProvider');
  }

  const ld = useFlags<LaunchDarklyFlags>();
  const { partner } = usePartnerProfile();

  return {
    ld,
    partnerFlags: partner?.featureCustomizations,
  };
}
